<template>
  <div class="poster-wrap">
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >新增社区</el-button
    >
    <el-dialog
      title="新增社区列表"
      width="1200px"
      :visible.sync="dialogVisible"
    >
      <el-form ref="form" label-width="100px">
        <el-form-item label="渠道：">
          <el-input v-model="com.channelName"></el-input>
        </el-form-item>
        <el-form-item label="渠道账号：">
          <el-input v-model="com.channelAccount"></el-input>
        </el-form-item>
        <el-form-item label="图标：">
          <upload @uploaded="iconimg"></upload>
        </el-form-item>
        <el-form-item label="二维码：">
          <upload @uploaded="qrimg"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Upload from 'components/upload';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      dialogVisible: false,
      com: {}
    };
  },
  methods: {
    ...mapActions('community', ['createCom']),
    iconimg(data) {
      this.com.iconUrl = data;
    },
    qrimg(data) {
      this.com.orCodeUrl = data;
    },
    handleSave() {
      this.createCom({
        ...this.com
      })
        .then(res => {
          this.$message.success('操作成功！');
          this.$emit('refresh');
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    }
  },
  components: {
    Upload
  }
};
</script>
<style lang="less"></style>
